import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { ConsentProvider } from "@/context/ConsentContext";
import Layout from "@/components/site/Layout";
import { CookieBanner } from "@/components/site/CookieBanner";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import CategoryPage from "@/pages/CategoryPage";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import NotFound from "@/pages/NotFound";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PackingSlip from "@/pages/PackingSlip";

const TitleSync = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = pathname === "/" ? "Laszlo Abonyi - Paintings" : "Laszlo Abonyi";
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App grain">
      <ConsentProvider>
        <CartProvider>
          <BrowserRouter>
            <TitleSync />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/category/:slug" element={<CategoryPage />} />
                <Route path="/artwork/:slug" element={<ProductDetail />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/success" element={<OrderSuccess />} />
                <Route path="/about" element={<About />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/orders/:id/slip" element={<ProtectedRoute><PackingSlip /></ProtectedRoute>} />
            </Routes>
            <CookieBanner />
          </BrowserRouter>
        </CartProvider>
      </ConsentProvider>
      <Toaster position="bottom-right" toastOptions={{ style: { borderRadius: 0, background: "#FDFBF7", border: "1px solid #E5E0D8", color: "#1A1A1A" } }} />
    </div>
  );
}

export default App;
